import { render, staticRenderFns } from "./Huizong.vue?vue&type=template&id=285c0928&scoped=true"
import script from "./Huizong.vue?vue&type=script&lang=js"
export * from "./Huizong.vue?vue&type=script&lang=js"
import style0 from "./Huizong.vue?vue&type=style&index=0&id=285c0928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285c0928",
  null
  
)

export default component.exports